var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"row justify-space-between pa-3 mb-3 bar-title"},[_c('div',{staticClass:"font-5 font-weight-bold"},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.title)+" ")],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }